export const Actions = {
  async getTelemetryActiveInfo({ commit }) {
    const result = {};
    if (result) commit('setTelemetryActiveInfo', result);
    return result;
  },
};
